export default __webpack_public_path__ + "static/leaderboard-screen-bcbbdb8b3b7209552bd4b3b9e3e70694.webp";